const db = [
    {
        id: 1,
        link: 'selectFlooring',
        categoria: 'select flooring',
        descripcion: 'Suitable for both commercial and residential use, including bathrooms and kitchens, as they are water-resistant. Their texture achieves a natural and realistic appearance, making them comfortable to walk on. This line features 18 unique designs: 14 wood-like and 4 stone-like. They have a thickness of 5.5 mm and include a 0.5 mm wear layer, making them highly resistant to wear and impacts—perfect for high-traffic areas.  Thanks to their four-sided “click” locking system, they can be quickly installed on any firm and smooth surface. Installation does not require any toxic adhesives, avoiding a wet and time-consuming construction process. The underside includes an acoustic and thermal mat that corrects minor imperfections in the existing surface. To complement our floors and achieve a flawless finish, we also offer our line of baseboards in tones similar to the floors or in white, available in various heights. ',
        destacado: [
            {
                id: 1,
                nombre: 'Water-resistant',
                img: 'resistenteAlAgua.svg',
                link: 'wr-08-roble'
            },
            {
                id: 2,
                nombre: 'Easy to install',
                img: 'FacilInstalar.svg'
            },
            {
                id: 3,
                nombre: 'Quiet floors',
                img: 'PisosSilenciosos.svg'
            },
            {
                id: 4,
                nombre: 'Ultra-resistant',
                img: 'SuperResistentes.svg'
            }

        ],
        productos: [
            {
                id: 1,
                nombre: 'S-1 Cementi Silver',
                material: '100% pvc virgen',
                simil: 'Porcelanatto',
                medidas: '305mm x 610mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'B-80 STEEL',
                        img: 'Zocalos de PVC/B-80-Steel-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/s-1-cementi-silver.jpg',
                link: 's-1-cementi-silver'
            },
            {
                id: 2,
                nombre: 'S-2 NATURAL STONE',
                material: '100% pvc virgen',
                simil: 'Porcelanatto',
                medidas: '305mm x 610mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/s-2-natural-stone.jpg',
                link: 's-2-natural-stone'

            },
            {
                id: 4,
                nombre: 'S-3 Cementi Grigio',
                material: '100% pvc virgen',
                simil: 'Porcelanatto',
                medidas: '305mm x 610mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'B-80 STEEL',
                        img: 'Zocalos de PVC/B-80-Steel-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/S-3 Cementi Grigio I.jpg',
                link: 's-3-cementi-grigio'

            },
            {
                id: 5,
                nombre: 'S-4 Light Beige  Loose Lay',
                material: '100% pvc virgen',
                simil: 'Porcelanatto',
                medidas: '450mm x 450mm',
                espesor: '5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/S-4-Light-Beige-compressor.webp',
                link: 's-4'

            },
            {
                id: 6,
                nombre: 'W-01 BLANCO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-01 Blanco',
                        img: 'Zocalos de PVC/W-01 Blanco Zocalo.jpg'
                    }
                ],
                img: 'Select Flooring/W-01 Blanco I.jpg',
                link: 'w-01-blanco'

            },
            {
                id: 7,
                nombre: 'W-03 GRIS',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-21',
                        img: 'Zocalos de PVC/W-21-Zocalo-Gris-Titanio-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/W-03 Gris I.jpg',
                link: 'w-03-gris'
            },
            {
                id: 8,
                nombre: 'W-04 CHOCOLATE',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-04',
                        img: 'Zocalos de PVC/W-04 web baja.jpg'
                    },
                    {
                        nombre:'W-06',
                        img: 'Zocalos de PVC/W-06-Zocalo-Rustico-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/W-04 Chocolate.jpg',
                link: 'w-04-chocolate'
            },
            {
                id: 9,
                nombre: 'W-05 ROBLE CAL',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'C-120 wood',
                        img: 'Zocalos de PVC/C-120-Wood1-1536x1024.webp'
                    },
                    {
                        nombre:'W-05',
                        img: 'Zocalos de PVC/W-05 Roble Cal Zocalo.jpg'
                    },
                    {
                        nombre:'WR-17',
                        img: 'Zocalos de PVC/WR-17 Zocalo Pino Natural ALTA (1).jpg'
                    }
                ],
                img: 'Select Flooring/W-05 Roble Cal I (1).jpg',
                link: 'w-05-roble-cal'
            },
            {
                id: 10,
                nombre: 'W-06 RUSTICO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'C-120 wood',
                        img: 'Zocalos de PVC/C-120-Wood1-1536x1024.webp'
                    },
                    {
                        nombre:'W-04',
                        img: 'Zocalos de PVC/W-04 web baja.jpg'
                    },
                    {
                        nombre:'W-06',
                        img: 'Zocalos de PVC/W-06-Zocalo-Rustico-1536x1024.webp'
                    },
                    {
                        nombre:'WR-16',
                        img: 'Zocalos de PVC/WR-16 Petiribi Zocalo.jpg'
                    }
                ],
                img: 'Select Flooring/W-06 Rustico I.jpg',
                link: 'w-06-rustico'
            },
            {
                id: 11,
                nombre: 'W-07 TANGO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-01 BLANCO',
                        img: 'Zocalos de PVC/W-01 Blanco Zocalo.JPG'
                    }
                ],
                img: 'Select Flooring/W-07 Tango.jpg',
                link: 'w-07-tango'
            },
            {
                id: 12,
                nombre: 'W-08 ROBLE',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'C-120 wood',
                        img: 'Zocalos de PVC/C-120-Wood1-1536x1024.webp'
                    },
                    {
                        nombre:'W-06',
                        img: 'Zocalos de PVC/W-06-Zocalo-Rustico-1536x1024.webp'
                    },
                    {
                        nombre:'W-08',
                        img: 'Zocalos de PVC/W-08 09 Roble y Maple Zocalo.jpg'
                    },
                    {
                        nombre:'W-10',
                        img: 'Zocalos de PVC/W-10-Incienso-Zocalos--1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/W-08 Roble.jpg',
                link: 'w-08-roble'
            },
            {
                id: 13,
                nombre: 'W-09 MAPLE',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-08',
                        img: 'Zocalos de PVC/W-08 09 Roble y Maple Zocalo.jpg'
                    }
                ],
                img: 'Select Flooring/W-09 Maple I.jpg',
                link: 'w-09-maple'
            },
            {
                id: 14,
                nombre: 'W-10 INCIENSO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion:[
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'C-120 wood',
                        img: 'Zocalos de PVC/C-120-Wood1-1536x1024.webp'
                    },
                    {
                        nombre:'W-04',
                        img: 'Zocalos de PVC/W-04 web baja.jpg'
                    },
                    {
                        nombre:'W-06',
                        img: 'Zocalos de PVC/W-06-Zocalo-Rustico-1536x1024.webp'
                    },
                    {
                        nombre:'WR-16',
                        img: 'Zocalos de PVC/WR-16 Petiribi Zocalo.jpg'
                    },
                    {
                        nombre:'W-10',
                        img: 'Zocalos de PVC/W-10-Incienso-Zocalos--1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/W-10 Incienso I.jpg',
                link: 'w-10-incienso'
            },
            {
                id: 15,
                nombre: 'W-11 VISON',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion:[
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/W-11 Vison.jpg',
                link: 'w-11-vision'
            },
            {
                id: 16,
                nombre: 'W-12 CEREZO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion:[
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-12',
                        img: 'Zocalos de PVC/W-12-web-baja.webp'
                    }
                ],
                img: 'Select Flooring/W-12 Cerezo.jpg',
                link: 'w-12-cerezo'
            },
            {
                id: 17,
                nombre: 'W-14 ROBLE NATURAL',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion:[
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-05',
                        img: 'Zocalos de PVC/W-05 Roble Cal Zocalo.jpg'
                    },
                    {
                        nombre:'WR-17',
                        img: 'Zocalos de PVC/WR-17 Zocalo Pino Natural ALTA (1).jpg'
                    }
                ],
                img: 'Select Flooring/W-14 Roble Natural I.jpg',
                link: 'w-14-roble-natural'
            },
            {
                id: 18,
                nombre: 'W-20 Roble Americano',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion:[
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    }
                ],
                img: 'Select Flooring/W-20-Roble-Americano-compressor.jpg',
                link: 'w-20-roble-americano'
            },
            {
                id: 19,
                nombre: 'W-21 GRIS TITANIO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '5,5mm',
                capaUso: '0,5mm',
                combinacion:[
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-21',
                        img: 'Zocalos de PVC/W-21-Zocalo-Gris-Titanio-1536x1024.webp'
                    },
                    {
                        nombre:'WR-17',
                        img: 'Zocalos de PVC/WR-17 Zocalo Pino Natural ALTA (1).jpg'
                    }
                ],
                img: 'Select Flooring/W-21-Gris-Titanio-compressor.jpg',
                link: 'w-21-gris-titanio'
            },

        ]
    },
    {
        id: 2,
        link: 'classicFlooring',
        categoria: 'classic flooring',
        descripcion: 'Suitable for residential environments, including bathrooms and kitchens, as they are water-resistant. Their texture achieves a natural and realistic appearance, making them comfortable to walk on. We offer 6 unique wood-like designs in this line, each with a thickness of 4.7 mm. Thanks to their four-sided "click" locking system, they can be quickly installed on any firm and smooth surface. Installation does not require any toxic adhesives, avoiding a wet and long-lasting construction process. The underside includes an acoustic and thermal mat that corrects minor imperfections in the existing surface. To complement our floors and achieve a flawless finish, we also offer our line of baseboards in tones similar to the floors or in white, available in various heights.',
        destacado: [
            {
                id: 1,
                nombre: 'water resistance',
                img: 'resistenteAlAgua.svg'
            },
            {
                id: 2,
                nombre: 'easy to install',
                img: 'FacilInstalar.svg'
            },
            {
                id: 3,
                nombre: 'quiet floring',
                img: 'PisosSilenciosos.svg'
            },
            {
                id: 4,
                nombre: 'Ultra-resistant',
                img: 'SuperResistentes.svg'
            }

        ],
        productos: [
            {
                id: 1,
                nombre: 'WR-05 ROBLE CAL',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '4,7mm',
                capaUso: '0,2mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'C-120 wood',
                        img: 'Zocalos de PVC/C-120-Wood1-1536x1024.webp'
                    },
                    {
                        nombre:'W-08',
                        img: 'Zocalos de PVC/W-08 09 Roble y Maple Zocalo.jpg'
                    },
                    {
                        nombre:'W-10',
                        img: 'Zocalos de PVC/W-10-Incienso-Zocalos--1536x1024.webp'
                    }
                ],
                img: 'Classic Flooring/w05_roble_cal.jpg',
                link: 'wr-05-roble-cal'
            },
            {
                id: 2,
                nombre: 'WR-08 ROBLE',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '4,7mm',
                capaUso: '0,2mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'C-120 wood',
                        img: 'Zocalos de PVC/C-120-Wood1-1536x1024.webp'
                    },
                    {
                        nombre:'W-06',
                        img: 'Zocalos de PVC/W-06-Zocalo-Rustico-1536x1024.webp'
                    },
                    {
                        nombre:'W-08',
                        img: 'Zocalos de PVC/W-08 09 Roble y Maple Zocalo.jpg'
                    },
                    {
                        nombre:'W-10',
                        img: 'Zocalos de PVC/W-10-Incienso-Zocalos--1536x1024.webp'
                    }
                ],
                img: 'Classic Flooring/WR-08 Roble.jpg',
                link: 'wr-08-roble'

            },
            {
                id: 3,
                nombre: 'WR-16 PETIRIBI',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '4,7mm',
                capaUso: '0,2mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'WR-16',
                        img: 'Zocalos de PVC/WR-16 Petiribi Zocalo.jpg'
                    }
                ],
                img: 'Classic Flooring/WR-16 Petiribi I.jpg',
                link: 'wr-16-petiribi'

            },
            {
                id: 4,
                nombre: 'WR-17 PINO NATURAL',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '4,7mm',
                capaUso: '0,2mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-05',
                        img: 'Zocalos de PVC/W-05 Roble Cal Zocalo.jpg'
                    },
                    {
                        nombre:'WR-17',
                        img: 'Zocalos de PVC/WR-17 Zocalo Pino Natural ALTA (1).jpg'
                    }
                ],
                img: 'Classic Flooring/WR-17 Pino Natural I.jpg',
                link: 'wr-17-pino-natural'

            },
            {
                id: 5,
                nombre: 'WR-18 ABETO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '4,7mm',
                capaUso: '0,2mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    },
                    {
                        nombre:'W-01 BLANCO',
                        img: 'Zocalos de PVC/W-01 Blanco Zocalo.JPG'
                    }
                ],
                img: 'Classic Flooring/WR-18 Abeto I.jpg',
                link: 'wr-18-abeto'

            },
            {
                id: 6,
                nombre: 'WR-19 ROBLE NÓRDICO',
                material: '100% pvc virgen',
                simil: 'Madera',
                medidas: '180mm x 1220mm',
                espesor: '4,7mm',
                capaUso: '0,2mm',
                combinacion: [
                    {
                        nombre:'B-80',
                        img: 'Zocalos de PVC/B-80-1536x1024.webp'
                    }
                ],
                img: 'Classic Flooring/WR-19 Roble Nordico I.jpg',
                link: 'wr-19-roble-nordico'
            }
        ]
    },
    {
        id: 5,
        link: 'giantWallPanels',
        categoria: 'giant wall panels',
        descripcion: 'With unique marble and stone designs from world-leading trends, PVC panels are the ideal solution for wall coverings in bathrooms, kitchens, living rooms, and workspaces in your home or office. They are perfect for space renovations or new design projects. Thanks to their new technology, installation is fast, simple, and clean, avoiding the need for long-term construction work. Unlike traditional panels, this innovative product is water and moisture-resistant, while also being easy to maintain. Offering a unique appearance, the panels measure 1.22 meters wide by 2.6 meters high, making them the largest on the market and unique in the country. With their distinguished mirrored finish, the panels provide a modern, bright, and elegant look.',
        destacado: [
            {
                id: 1,
                nombre: 'Water-resistant',
                img: 'resistenteAlAgua.svg'
            },
            {
                id: 2,
                nombre: 'Easy to install',
                img: 'FacilInstalar.svg'
            },
            {
                id: 3,
                nombre: 'Glossy finish',
                img: 'AcabadoBrillante.svg'
            },
            {
                id: 4,
                nombre: 'Large size',
                img: 'TamanosAmplios.svg'
            }

        ],
        productos: [
            {
                id: 2,
                nombre: 'M-02 IVORY',
                material: '100% pvc virgen',
                simil: 'Cemento',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-02 Ivory.jpg',
                link: 'm-02-ivory'

            },
            {
                id: 4,
                nombre: 'M-04 CARRARA',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-04 Carrara.jpg',
                link: 'm-04-carrara'

            },
            {
                id: 5,
                nombre: 'M-05 MARRÓN EMPERADOR',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-05 Marron Emperador.jpg',
                link: 'm-05-marron-emperador'

            },
            {
                id: 6,
                nombre: 'M-06 MARQUINA',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-06 Marquina.jpg',
                link: 'm-06-marquina'
            },
            {
                id: 7,
                nombre: 'M-07 CALACATTA',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-07 Calacatta.jpg',
                link: 'm-07-calacatta'
            },
            {
                id: 8,
                nombre: 'M-08 CALACATTA GOLD',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-08 Calacatta Gold.jpg',
                link: 'm-08-calacatta-gold'
            },
            {
                id: 9,
                nombre: 'M-09 TRAVERTINO',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-09 TRAVERTINO.png',
                link: 'm-09-travertino'
            },
            {
                id: 10,
                nombre: 'M-10 TUNDRA GRAY',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-10 TUNDRA GREY.jpeg',
                link: 'm-10-tundra-gray'
            },
            {
                id: 11,
                nombre: 'M-11 ROYAL BEIGE',
                material: '100% pvc virgen',
                simil: 'Marmol',
                medidas: '1220mm x 2600mm',
                espesor: '3mm',
                img: 'Giant Wall Panels/M-11 ROYAL BEIGE.jpg',
                link: 'm-11-royal-beige'
            },
            
        ]
    },
]

export function Data() {
    return (db)
}
export default function DataFind(p) {
    return (db.find(parametro => parametro.link === p))
}
export function DataFindProduct(c, p) {
    const categoria = db.find(parametro => parametro.link === c)
    return (categoria.productos.find(productos => productos.id.toString() === p))
}